import { createPaginatedList } from "MODULES/shared/pagination";
import api from "APP_ROOT/api";
import { useCurrentUser } from "APP_ROOT/hooks";
import _ from "lodash";

export default createPaginatedList({
  listId: "shoppingLists",
  fetch: api.shoppingList.search,
  initialSettings: {
    sort: "most_recent_sale_date"
  }
});

export const residentExpertSearch = createPaginatedList({
  listId: "residentExpertSearch",
  fetch: params =>
    api.shoppingList.search(
      _.merge(params, {
        resident_expert_id: useCurrentUser().id
      })
    ),
  initialSettings: {
    sort: "tier_type",
    reverse: true
  }
});



// WEBPACK FOOTER //
// ./app/modules/MyShoppingList/pagination.js